import { EventBus } from "@xbs/lib-state";
import ActionQueue from "./ActionQueue";
import { CalendarID, EventID } from "./constants";
export default class RestDataProvider extends EventBus {
    constructor(url) {
        super();
        this._customHeaders = {};
        this._url = url;
        this._queue = new ActionQueue();
        const defaultHandlers = {
            "add-event": {
                ignoreID: true,
                kind: EventID,
                handler: (data) => this.send("events", "POST", data.event),
            },
            "update-event": {
                kind: EventID,
                handler: (data) => this.send(`events/${data.id}`, "PUT", data.event),
            },
            "delete-event": {
                kind: EventID,
                handler: (data) => this.send(`events/${data.id}`, "DELETE"),
            },
            "add-calendar": {
                ignoreID: true,
                kind: CalendarID,
                handler: (data) => this.send("calendars", "POST", data.calendar),
            },
            "update-calendar": {
                kind: CalendarID,
                handler: (data) => this.send(`calendars/${data.id}`, "PUT", data.calendar),
            },
            "delete-calendar": {
                kind: CalendarID,
                handler: (data) => this.send(`calendars/${data.id}`, "DELETE"),
            },
        };
        const handlers = this.getHandlers(defaultHandlers);
        for (const x in handlers) {
            this.on(x, (ev) => {
                if (!ev.skipProvider)
                    this._queue.add(x, ev, handlers[x]);
            });
        }
    }
    getIDResolver() {
        return this._queue.resolve.bind(this._queue);
    }
    getEvents() {
        return this.send("events", "GET").then(this.parseEvents);
    }
    getCalendars() {
        return this.send("calendars", "GET");
    }
    setHeaders(headers) {
        this._customHeaders = headers;
    }
    getHandlers(handlers) {
        return handlers;
    }
    send(url, method, data, customHeaders = {}) {
        const headers = {
            "Content-Type": "application/json",
            ...customHeaders,
            ...this._customHeaders,
        };
        const req = {
            method,
            headers,
        };
        if (data) {
            req.body = typeof data === "object" ? JSON.stringify(data) : data;
        }
        return fetch(`${this._url}/${url}`, req).then(res => res.json());
    }
    parseEvents(data) {
        for (let i = 0; i < data.length; i++) {
            data[i].start_date = new Date(data[i].start_date);
            data[i].end_date = new Date(data[i].end_date);
        }
        return data;
    }
}
//# sourceMappingURL=RestDataProvider.js.map